import React, { useState } from 'react';
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { Breadcrumb } from 'antd';

import { useFunctionNamesByOrg } from "modules/functionRegister/hooks";

import * as Grid from "components/Grid";

import Title from "components/Title";
import Spacer from "components/Spacer";
import Container from "components/Container";
import Card from 'components/Card';
import { LoadingOutlined } from '@ant-design/icons';

import cls from "./FunctionNameOrganizations.module.scss";

const FunctionNameOrganizations = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [search, __] = useState(0);

  const defaultParams = {
    search,
    perPage: 10000,
  }

  const { items, isFetched } = useFunctionNamesByOrg({
    params: defaultParams,
  });

  return (
    <Container>
      <Spacer size={35} />

      <Breadcrumb separator=">">
        {/* <Breadcrumb.Item href='/'>{t('home')}</Breadcrumb.Item> */}
        <Breadcrumb.Item href='/'>{t('home')}</Breadcrumb.Item>
        <Breadcrumb.Item>{t('organization_stats')}</Breadcrumb.Item>
      </Breadcrumb>

      <Spacer size={32} />

      <Title align='left' text={t('organization_stats')} />

      <Spacer size={40} />

      <Spacer size={40} />

      {items.length > 0 && (
        <Grid.Row gutter={[24, 24]}>
          {items
            .map((item, index) => (
              <Grid.Col span={6} key={item.id} data-aos="fade-up" data-aos-delay={index * 50}>
                <Card
                  id={item.id}
                  uuid={item.file.uuid}
                  name={item.name[i18n.language]}
                  count={item.count}
                  onClick={() => navigate(`/function-names?organization_id=${item.id}`)}
                />
              </Grid.Col>
            ))}
        </Grid.Row>
      )}

      {
        items.length === 0 && isFetched && (<div className={cls.noData}>{t('no_data')}</div>)
      }

      {
        !isFetched && (<div className={cls.loading}><LoadingOutlined /></div>)
      }

      <Spacer size={140} />
    </Container>
  )
}

export default FunctionNameOrganizations;